import Ajax from '../../../../common/js/Ajax.js';
import ButtonUtils from '../../../../common/js/ButtonUtils.js';
import Form from '../../../../common/js/form/Form.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import UrlParser from '../../../../common/js/UrlParser.js';
import TippspielWidget from '../TippspielWidget.js';

import TEMPLATE from './BetWidget.hbs';

export default class BetWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
		this.userId = parseInt(UrlParser.getParams()['userId']) || undefined;
	}
	
	getGoals($input) {
		var goals = parseInt($input.val(), 10);
		return isNaN(goals) ? null : goals;
	}

	onLoginReady() {
		Ajax.rpc('/bet', {userId: this.userId}, bet => {
			if (this.userId) {
				this.setPageHeadline('Tipp von ' + bet.userName);
			}
			
			$.each(bet.phases, (index, phase) => {
				var anyBetOpen = false;
				$.each(phase.matches, (index, match) => {
					anyBetOpen |= match.betOpen;
				});
				phase.anyBetOpen = anyBetOpen;
			});
			
			this.$widget.html(TEMPLATE(bet));
			
			Form.onButton(this.$widget.find('[type="submit"]'), action => {
				this.$widget.find('.js_local-messages').empty();

				var matchBets = [];
				action.find('.js_match').each((index, match) => {
					var $match = $(match);
					matchBets.push({
						matchId: parseInt($match.attr('data-id'), 10),
						goals1: this.getGoals($match.find('[name="bet1"]')),
						goals2: this.getGoals($match.find('[name="bet2"]'))
					})
				});
				
				var $messages = action.$button.closest('.js_submit-messages-group').find('.js_local-messages');
				this.$widget.find('[type="submit"]').prop('disabled', true);
				Ajax.rpc('/placeBet', {
					secret: action.findField('secret').is(':checked'),
					winnerId: action.findField('winner').val(),
					matchBets
				}, () => {
					this.$widget.find('[type="submit"]').prop('disabled', false);
					ButtonUtils.setState(action.$button, 'success');
					MessageUtils.ok($messages, 'Super, dein Tipp wurde gespeichert.');
				}, error => {
					this.$widget.find('[type="submit"]').prop('disabled', false);
					ButtonUtils.setState(action.$button, 'none');
					MessageUtils.error($messages, TippspielWidget.getFailedMessage(), error);
				});
			});
		}, error => {
			MessageUtils.error(this.$widget, TippspielWidget.getFailedMessage(), error);
		});
	}
	
	isLoginRequired() {
		return !this.userId;
	}

}
